module.exports = __webpack_public_path__ + "static/media/PC_Data_Desenvolvimento_Web_Full_Stack.5181355d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/desWebFullStack/PC_Data_Desenvolvimento_Web_Full_Stack.png
// module id = 83
// module chunks = 0